// What a help entry's button does (shared/help.ts HelpAction): open a panel, a part of Settings or Connect, a new board
// of a kind, or the ? panel. Always the user's own click: in the chat it is the go-there link under a reply
// (src/agent/GoPlaces.tsx), in the ? panel a row's button.

import { HELP_PANELS, type HelpAction } from "../../shared/help";
import { isMac } from "../lib/util";
import { createBoard, newBoardName } from "../state/actions";
import { get, set, type Panel } from "../state/store";
import { startOf } from "../boards/start";

// every panel a help action names is one the board has (a rename there fails the typecheck here)
HELP_PANELS satisfies readonly Panel[];

/** Does what a help entry's button says. */
export function runHelpAction(a: HelpAction): void {
  const s = get();
  if (s.guest) return;
  switch (a.do) {
    case "panel":
      set({ panel: a.panel, panelArg: null });
      return;
    case "connect":
      set({ panel: "connect", panelArg: { ...a.arg } });
      return;
    case "settings":
      set({ panel: "settings", panelArg: { tab: a.tab } });
      return;
    case "newboard":
      if (a.kind) {
        const start = startOf(a.kind);
        createBoard(newBoardName(start.name), start.theme, true, a.kind);
        set({ panel: null, panelArg: null });
      } else set({ panel: "newboard", panelArg: null });
      return;
    case "help":
      set({ panel: "help", panelArg: null });
      return;
  }
}

/** Keys as this computer writes them: ⌘ on a Mac, Ctrl elsewhere, with Shift and Alt spelled out. */
export function keyLabel(keys: string): string {
  if (isMac) return keys;
  return keys.replace(/⇧⌘/g, "Ctrl+Shift+").replace(/⌥⌘/g, "Ctrl+Alt+").replace(/⌘/g, "Ctrl+").replace(/⇧(?=\S)/g, "Shift+").replace(/⌥(?=\S)/g, "Alt+").replace(/⇧/g, "Shift").replace(/⌥/g, "Alt");
}
